import { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";

export default function Layout({ children }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-background">
      {/* Sidebar */}
      <Sidebar
        variant="expanded"
        isMobileOpen={mobileNavOpen}
        onMobileToggle={setMobileNavOpen}
        onToggle={(collapsed) => setSidebarCollapsed(collapsed)}
      />

      {/* Main Content */}
      <div
        className={`flex flex-col flex-1 min-w-0 transition-all duration-300 ${sidebarCollapsed ? "md:pl-16" : "md:pl-64"
          }`}
      >
        <Header
          mobileNavOpen={mobileNavOpen}
          onMobileNavToggle={() => setMobileNavOpen((open) => !open)}
        />

        {/* Main Content */}
        <main
          id="main-content"
          className="flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-6 bg-background"
          style={{
            scrollbarWidth: "thin", // Firefox
            scrollbarColor: "#888 #f0f0f0", // Firefox thumb | track
          }}
        >
          {children}

          <style jsx>{`
                      /* Chrome, Edge, Safari */
                      #main-content::-webkit-scrollbar {
                        width: 6px;
                      }
                      #main-content::-webkit-scrollbar-thumb {
                        background-color: #888;
                        border-radius: 3px;
                      }
                      #main-content::-webkit-scrollbar-track {
                        background-color: #f0f0f0;
                      }
          `}</style>
        </main>
      </div>
    </div>
  );
}
